import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight,ChevronDown  } from "lucide-react"; 
import { isMobile, isTablet, isBrowser } from 'react-device-detect';

function ImageSlider() {
	const [banner, setBanner] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [current, setCurrent] = useState(0);
	const [marq, setMarq] = useState([]);
	
	const handlePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/banner", payload);
			console.log(response.data);
			// Loop data (array)
			setBanner(response.data.slice(0, 10) || []);
		} catch (err) {
			console.error("API Error:", err);

			if (err.response) {
				console.error("Status:", err.response.status);
				console.error("Headers:", err.response.headers);
				console.error("Response data:", err.response.data);				
				
			} else if (err.request) {
				console.error("No response received:", err.request);
				setError("No response received from server.");
			} else {
				console.error("Request Error:", err.message);
				setError(err.message || "Something went wrong");
			}
		}  finally {
		  setLoading(false);
		}
	};
	
	
	const marqPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'0',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/marque", payload);
			
			
			// Loop data (array)
			setMarq(response.data.slice(0, 10) || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		handlePost();
		marqPost();
	}, []);
	
	
	useEffect(() => {
		if (banner.length === 0) return;
		const interval = setInterval(() => {
		  setCurrent((prev) => (prev + 1) % banner.length);
		}, 5000);
		return () => clearInterval(interval);
	}, [banner]);

	const nextSlide = () => {
		setCurrent((prev) => (prev + 1) % banner.length);
	};

	const prevSlide = () => {
		setCurrent((prev) => (prev - 1 + banner.length) % banner.length);
	};
	if (banner.length === 0) {
		return <div className="h-screen flex items-center justify-center">Loading...</div>;
	}
	
	return (
	<>
		{/*
		<div className="relative w-full h-[60vh] md:h-[80vh] overflow-visible z-0">	
			
			{banner.map((slide, index) => (
				<img
					key={slide.id}
					src={`${import.meta.env.VITE_API_SOURCE_URL}${slide.images_path}`}
					alt={`Slide ${slide.id}`}
					className={`absolute inset-0 w-full h-[60vh] md:h-[80vh] object-cover transition-opacity duration-1000
					${index === current ? "opacity-100 animate-zoom" : "opacity-0"}`}
					onError={(e) => (e.target.style.display = "none")}	
				/>
			))}
			
		  
		  <button
			onClick={prevSlide}
			className="absolute left-1 md:left-4 top-1/2 -translate-y-1/2 bg-[#016C94] text-white p-2 md:p-4 rounded-full hover:bg-black/70"
		  >
			<ChevronLeft size={isMobile ? 10 : 24} />
		  </button>

		  
		  <button
			onClick={nextSlide}
			className="absolute right-1 md:right-4 top-1/2 -translate-y-1/2 bg-[#016C94] text-white p-2 md:p-4 rounded-full hover:bg-black/70"
		  >
			<ChevronRight size={isMobile ? 10 : 24} />
		  </button>

		  
		  <div className="absolute bottom-2 md:bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
			{banner.map((_, index) => (
			  <button
				key={index}
				onClick={() => setCurrent(index)}
				className={` w-2 md:w-4 h-2 md:h-4 rounded-full ${
				  index === current ? "bg-white" : "bg-gray-400"
				}`}
			  />
			))}
		  </div>
		</div>
		*/}
		<section className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden">
		  {/* Background Video */}
		  <video
			className="absolute top-0 left-0 w-full h-full object-cover"
			src="/video/video.mp4"
			autoPlay
			muted
			loop
			playsInline
		  ></video>

		  {/*  */}
		  

		  {/* Text content 
		  <div className="absolute inset-0 bg-black/50"></div>
		  <div className="absolute bottom-0 left-0 right-0 z-10 flex flex-col items-center justify-center  text-center text-white px-4">
			<h1 className="text-5xl md:text-7xl font-bold mb-4">
				Welcome to UCTC
			</h1>
			<p className="text-lg md:text-2xl mb-6 max-w-2xl">
			    Empowering Students for a Brighter Future
			</p>
			<a
			  href="/apply-online"
			  className="bg-yellow-500 hover:bg-yellow-600 px-8 py-3 rounded-full text-lg font-medium transition-all"
			>
			  Apply Now
			</a>
		  </div>
		  */}
		</section>
		
		 <div className="bg-[#016C94] text-white py-3">
			<div className="container mx-auto flex items-center">
				{/* Label */}
				<span className="font-bold mr-4">Latest:</span>

				<div className="overflow-hidden whitespace-nowrap w-full">
				   <div className="animate-marquee inline-block" 
					style={{
					  display: "inline-block",
					  whiteSpace: "nowrap"					  
					}}>
					<marquee direction="left" loop="infinite">
						{marq.map((item, index) => (
					  
						  <Link
							key={item.id || index}
							to={item.link}
							className="inline-flex items-center mr-10 hover:underline"							
						  >
							<span className="bg-white text-blue-600 text-xs px-2 py-0.5 rounded mr-2">
							  {new Date(item.date).toLocaleDateString()}
							</span>
							<span>{item.name}</span>
						  </Link>
					 
						))}
					</marquee>
				  </div>
				</div>
			</div>
		</div>
		<style>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
	</>
  );
}

export default ImageSlider;
